import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import { initAnalytics } from './lib/analytics'
import AuthShell from './AuthShell'
import AnalyticsProvider from './components/AnalyticsProvider'
import { SessionOrderAlertRuntime } from './components/SessionOrderAlertRuntime'
import { AuthProvider } from './contexts/AuthContext'

initAnalytics()

// Confirm to @capgo/capacitor-updater that this bundle loaded successfully.
// Must be called on every launch — if omitted the updater rolls back the bundle.
if (Capacitor.isNativePlatform()) {
  import('@capgo/capacitor-updater').then(({ CapacitorUpdater }) => {
    CapacitorUpdater.notifyAppReady()
      .catch(() => {})
      .finally(() => {
        void import('./lib/otaColdStartApply').then(({ applyPendingOtaOnColdStart }) => {
          void applyPendingOtaOnColdStart()
        })
      })
  }).catch(() => {})
  import('./lib/nativeOrderAlerts').then(({ initNativeOrderAlerts }) => {
    void initNativeOrderAlerts()
  }).catch(() => {})
}

ReactDOM.createRoot(document.getElementById('app') as HTMLElement).render(
  React.createElement(
    BrowserRouter,
    null,
    React.createElement(
      AuthProvider,
      null,
      React.createElement(
        React.Fragment,
        null,
        React.createElement(SessionOrderAlertRuntime),
        React.createElement(AnalyticsProvider, null, React.createElement(AuthShell)),
      ),
    ),
  ),
)
